import { useAuth } from '@/features/auth/contexts/AuthContext';
import { getAdminSimulatedTier, setAdminSimulatedTier, TierKey } from '@/features/subscription/hooks/useSubscription';
import { useState, useEffect } from 'react';
import { ShieldCheck } from 'lucide-react';

const PLANS: { key: TierKey; label: string; color: string }[] = [
  { key: 'free',     label: 'Free',   color: 'bg-muted text-muted-foreground' },
  { key: 'standard', label: 'Solo',   color: 'bg-blue-500/20 text-blue-400' },
  { key: 'pro',      label: 'Studio', color: 'bg-primary/20 text-primary' },
];

export function AdminPlanSwitcher() {
  const { isAdmin } = useAuth();
  const [current, setCurrent] = useState<TierKey>(getAdminSimulatedTier);

  useEffect(() => {
    const handler = () => setCurrent(getAdminSimulatedTier());
    window.addEventListener('admin-tier-change', handler);
    return () => window.removeEventListener('admin-tier-change', handler);
  }, []);

  if (!isAdmin) return null;

  return (
    <div className="flex items-center gap-1 px-2 py-1 rounded-xl bg-yellow-500/10 border border-yellow-500/20">
      <ShieldCheck size={12} className="text-yellow-500 shrink-0" />
      {PLANS.map(p => (
        <button
          key={p.key}
          onClick={() => { setAdminSimulatedTier(p.key); setCurrent(p.key); }}
          className={`text-[10px] font-bold px-2 py-0.5 rounded-lg transition-colors ${
            current === p.key ? p.color + ' ring-1 ring-current' : 'text-muted-foreground hover:text-foreground'
          }`}
        >
          {p.label}
        </button>
      ))}
    </div>
  );
}
